export default {
  LOADING_FIELD_FINISHED: '@@loader/FIELD_FINISHED',
  LOADING_FIELD_STARTED:  '@@loader/FIELD_STARTED',
  
  LOADING_FINISHED: '@@loader/FINISHED',
  LOADING_STARTED:  '@@loader/STARTED'
};
